import { getTokenBalance, useBoomWallet } from '@boomeme/wallet-sdk';
import { PublicKey } from '@solana/web3.js';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTradeStore } from '@/page/trade/store';
import connection from '@/lib/connection';

export const useSplTokenAmountChange = () => {
  const { setChainTokenAmount } = useTradeStore();
  const { address: tokenAddress } = useParams();
  const { walletAddress, chain } = useBoomWallet();

  useEffect(() => {
    let subscriptionId: number | null = null;

    const setupTokenMonitoring = async () => {
      try {
        if (chain !== 'solana' || !walletAddress || !tokenAddress) {
          setChainTokenAmount(0);
          return;
        }
        const tokenAccounts = await connection.getTokenAccountsByOwner(new PublicKey(walletAddress), {
          mint: new PublicKey(tokenAddress),
        });
        if (tokenAccounts.value.length === 0) {
          setChainTokenAmount(0);
        }
        const tokenInfo = await getTokenBalance(tokenAddress, walletAddress);
        if (tokenInfo?.uiAmount !== null && tokenInfo?.decimals) {
          setChainTokenAmount(tokenInfo.uiAmount);
        }
        let tokenAccountPubkey: PublicKey | null = null;
        tokenAccountPubkey = tokenAccounts.value[0].pubkey;
        subscriptionId = connection.onAccountChange(
          tokenAccountPubkey,
          async () => {
            const updatedTokenInfo = await getTokenBalance(tokenAddress, walletAddress);
            if (updatedTokenInfo?.uiAmount !== null && updatedTokenInfo?.decimals) {
              setChainTokenAmount(updatedTokenInfo.uiAmount);
            }
          },
          { commitment: 'confirmed' },
        );
      } catch (error) {
        setChainTokenAmount(0);
        console.error('Error setting up token monitoring:', error);
      }
    };

    setupTokenMonitoring();

    return () => {
      if (subscriptionId !== null) {
        connection.removeAccountChangeListener(subscriptionId);
      }
    };
  }, [walletAddress, tokenAddress, chain]);

  return null;
};
